import React from "react";
import Typewriter from "typewriter-effect";

const typewriterOptions = {
  strings: [
    "Software Development Engineer",
    "DevOps Engineer",
    "Linux Enthusiast",
  ],
  autoStart: true,
  loop: true,
  deleteSpeed: 50,
};

function Type() {
  return <Typewriter options={typewriterOptions} />;
}

export default React.memo(Type);
